"use client";

import { useRouter } from "next/navigation";
import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

type CTAButton = {
  text: string;
  url: string;
  className?: string;
};

interface CTAButtonsProps {
  primary: CTAButton;
  secondary: CTAButton;
  className?: string;
}

export function CTAButtons({ primary, secondary, className }: CTAButtonsProps) {
  const router = useRouter();

  return (
    <div className={cn("mt-8 max-xs:mb-0 max-sm:max-w-[260px] mx-auto mb-8 md:mb-16 flex flex-wrap justify-center gap-4", className)}>
      <button
        onClick={() => router.push(primary.url)}
        className={cn(
          "group w-full xs:w-auto inline-flex justify-center max-sm:min-w-[275px] items-center gap-2 rounded-full bg-brand-grey px-8 py-3 text-sm font-semibold text-brand-card hover:bg-brand-grey/90 transition-all duration-200 3xl:text-xl",
          primary.className
        )}
      >
        {primary.text}
        <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" />
      </button>

      <button
        onClick={() => router.push(secondary.url)}
        className={cn(
          "inline-flex w-full xs:w-auto justify-center max-sm:min-w-[275px] items-center gap-2 rounded-full border border-white/30 px-8 py-3.5 text-sm font-semibold text-white hover:bg-white/10 transition-all duration-200 3xl:text-xl",
          secondary.className
        )}
      >
        {secondary.text}
      </button>
    </div>
  );
}